/* ============================================================
   MIGHTYCUTE — Master Theme JavaScript (assets/theme.js)
   Zero dependencies. Feature-loaded Cart & Modular PDP.
   ============================================================ */

(function () {
  'use strict';

  window.ShopifyTheme = window.ShopifyTheme || {};
  window.ShopifyTheme.currencyFormat = window.ShopifyTheme.currencyFormat || 'Rs. ';

  function formatMoney(cents) {
    if (cents == null || isNaN(cents)) return '';
    var amount = (cents / 100).toFixed(2);
    return window.ShopifyTheme.currencyFormat + Number(amount).toLocaleString('en-IN', { minimumFractionDigits: 2 });
  }

  // Cart drawer prices: Rs. 999 instead of Rs. 999.00 (paise kept when there are any: Rs. 599.40)
  function formatMoneyShort(cents) {
    return formatMoney(cents).replace(/\.00$/, '');
  }

  function cleanVal(v) {
    return (v == null ? '' : String(v)).trim().toLowerCase();
  }

  /* ============================================================
     MOBILE GESTURE & PINCH-ZOOM SCROLL GUARD (iOS WebKit & Chrome)
     ============================================================ */
  // 1. Prevent WebKit proprietary gesture events (Safari & Chrome on iOS)
  // Only fires on 2-finger pinch/rotation gestures — zero overhead on 1-finger scrolling
  ['gesturestart', 'gesturechange', 'gestureend'].forEach(function (evt) {
    document.addEventListener(evt, function (e) {
      e.preventDefault();
    }, { passive: false });
  });

  // 2. Prevent double-tap zoom via native dblclick preventDefault without blocking touchmove
  document.addEventListener('dblclick', function (e) {
    e.preventDefault();
  }, { passive: false });

  /* ============================================================
     DRAWER & OVERLAY CONTROLLER
     ============================================================ */
  function openDrawer(id) {
    var target = document.getElementById(id);
    if (!target) return;
    closeAllOverlays();
    target.classList.add('on');
    var scrim = document.getElementById('scrim');
    if (scrim) scrim.classList.add('on');
    document.body.style.overflow = 'hidden';
    target.setAttribute('aria-hidden', 'false');
  }

  function closeAllOverlays() {
    document.querySelectorAll('.drawer.on, .modal.on').forEach(function (el) {
      el.classList.remove('on');
      el.setAttribute('aria-hidden', 'true');
    });
    var scrim = document.getElementById('scrim');
    if (scrim) scrim.classList.remove('on');
    document.body.style.overflow = '';
  }

  window.openDrawer = openDrawer;
  window.closeAllOverlays = closeAllOverlays;

  function initDrawers() {
    // Drawer triggers
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-drawer-trigger]');
      if (btn) {
        e.preventDefault();
        var drawerId = btn.getAttribute('data-drawer-trigger');
        if (drawerId) openDrawer(drawerId);
      }
    });

    // Close buttons & Scrim
    document.addEventListener('click', function (e) {
      var closeBtn = e.target.closest('[data-close], [data-close-drawer]');
      if (closeBtn) {
        e.preventDefault();
        closeAllOverlays();
      } else if (e.target && e.target.id === 'scrim') {
        e.preventDefault();
        closeAllOverlays();
      }
    });

    // Escape key
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' || e.key === 'Esc') {
        closeAllOverlays();
      }
    });
  }

  /* ============================================================
     CONFETTI BURST ANIMATION
     Lightweight, high-performance canvas confetti on step completion
     ============================================================ */
  function triggerMilestoneConfetti() {
    try {
      var canvas = document.getElementById('milestoneConfettiCanvas');
      if (!canvas) {
        canvas = document.createElement('canvas');
        canvas.id = 'milestoneConfettiCanvas';
        canvas.style.position = 'fixed';
        canvas.style.top = '0';
        canvas.style.left = '0';
        canvas.style.width = '100%';
        canvas.style.height = '100%';
        canvas.style.pointerEvents = 'none';
        canvas.style.zIndex = '999999';
        document.body.appendChild(canvas);
      }

      var ctx = canvas.getContext('2d');
      var dpr = window.devicePixelRatio || 1;
      canvas.width = window.innerWidth * dpr;
      canvas.height = window.innerHeight * dpr;
      ctx.scale(dpr, dpr);

      // Launch origin: cart drawer header area or upper center
      var cartEl = document.getElementById('cart');
      var originX = window.innerWidth / 2;
      var originY = window.innerHeight * 0.22;
      if (cartEl && cartEl.classList.contains('open')) {
        var rect = cartEl.getBoundingClientRect();
        originX = rect.left + rect.width / 2;
        originY = rect.top + 110;
      }

      var colors = ['#C61425', '#10B981', '#F59E0B', '#3B82F6', '#FFFFFF', '#111111'];
      var particles = [];
      var numParticles = 65;

      for (var i = 0; i < numParticles; i++) {
        var angle = (Math.PI * 2 * i) / numParticles + (Math.random() - 0.5);
        var speed = 4 + Math.random() * 8;
        particles.push({
          x: originX,
          y: originY,
          vx: Math.cos(angle) * speed,
          vy: Math.sin(angle) * speed - 4.5,
          size: 4 + Math.random() * 5,
          color: colors[Math.floor(Math.random() * colors.length)],
          rotation: Math.random() * 360,
          rotationSpeed: (Math.random() - 0.5) * 14,
          opacity: 1,
          gravity: 0.24,
          friction: 0.98,
          wobble: Math.random() * Math.PI * 2,
          wobbleSpeed: 0.12
        });
      }

      var startTime = Date.now();
      var duration = 2200;

      function frame() {
        var elapsed = Date.now() - startTime;
        if (elapsed > duration) {
          ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);
          return;
        }

        ctx.clearRect(0, 0, window.innerWidth, window.innerHeight);

        particles.forEach(function (p) {
          p.x += p.vx;
          p.y += p.vy;
          p.vy += p.gravity;
          p.vx *= p.friction;
          p.vy *= p.friction;
          p.rotation += p.rotationSpeed;
          p.wobble += p.wobbleSpeed;
          p.opacity = Math.max(0, 1 - elapsed / duration);

          ctx.save();
          ctx.translate(p.x, p.y);
          ctx.rotate((p.rotation * Math.PI) / 180);
          ctx.scale(Math.cos(p.wobble), 1);
          ctx.fillStyle = p.color;
          ctx.globalAlpha = p.opacity;
          ctx.fillRect(-p.size / 2, -p.size / 2, p.size, p.size * 1.5);
          ctx.restore();
        });

        requestAnimationFrame(frame);
      }

      requestAnimationFrame(frame);
    } catch (e) {
      console.warn('Confetti animation error:', e);
    }
  }

  /* ============================================================
     CART CONTROLLER
     ============================================================ */
  var grungeSingleHandles = [
    'wicked-lace-unisex-straight-fit-baggy-pants',
    'hellspawn-unisex-straight-fit-baggy-pants',
    'biohazard-blossom-unisex-straight-fit-baggy-pants',
    'breakout-rage-unisex-straight-fit-baggy-pants',
    'hells-blossom-unisex-straight-fit-baggy-pants-copy',
    'inferno-angel-unisex-straight-fit-baggy-pants',
    'python-rage-unisex-straight-fit-baggy-pants',
    'netherwing-unisex-straight-fit-baggy-pants-1',
    'nightbloom-unisex-straight-fit-baggy-pants',
    'frostbite-unisex-straight-fit-baggy-pants',
    'atonement-unisex-straight-fit-baggy-pants',
    'wasteland-unisex-straight-fit-baggy-pants',
    'bramble-unisex-straight-fit-baggy-pants',
    'fracture-unisex-straight-fit-baggy-pants',
    'curruptor-unisex-straight-fit-baggy-pants',
    'attonment-unisex-straight-fit-baggy-pants-copy'
  ];

  function extractItemSize(itm) {
    if (!itm) return '';
    if (itm.options_with_values && itm.options_with_values.length) {
      for (var j = 0; j < itm.options_with_values.length; j++) {
        var opt = itm.options_with_values[j];
        if (opt.name && opt.name.toLowerCase().indexOf('size') !== -1 && opt.value) {
          return opt.value.trim();
        }
      }
    }
    if (itm.variant_title) {
      if (itm.variant_title.indexOf('/') !== -1) {
        return itm.variant_title.split('/')[0].trim();
      } else if (itm.variant_title !== 'Default Title') {
        return itm.variant_title.trim();
      }
    }
    return '';
  }

  function getCustomerCartSize(cart, preferPrintedPant) {
    if (!cart || !cart.items || !cart.items.length) return 'Free Size';
    if (preferPrintedPant) {
      for (var p = 0; p < cart.items.length; p++) {
        var pItm = cart.items[p];
        var pH = (pItm.handle || '').toLowerCase();
        if (grungeSingleHandles.indexOf(pH) !== -1) {
          var pSz = extractItemSize(pItm);
          if (pSz) return pSz;
        }
      }
    }
    for (var i = 0; i < cart.items.length; i++) {
      var sz = extractItemSize(cart.items[i]);
      if (sz) return sz;
    }
    return 'Free Size';
  }

  /* ============================================================
     CART CONTROLLER: ETA, COUPONS, BILL BREAKUP, PREPAID & UPSELLS
     ============================================================ */
  var appliedCouponCode = '';
  try {
    appliedCouponCode = sessionStorage.getItem('mcx_applied_coupon') || '';
  } catch (e) {}

  function updateDeliveryEta() {
    var etaEl = document.getElementById('etaDateRange');
    if (!etaEl) return;
    var now = new Date();
    function addBusinessDays(startDate, days) {
      var d = new Date(startDate);
      var added = 0;
      while (added < days) {
        d.setDate(d.getDate() + 1);
        var dayOfWeek = d.getDay();
        if (dayOfWeek !== 0 && dayOfWeek !== 6) {
          added++;
        }
      }
      return d;
    }
    var dStart = addBusinessDays(now, 3);
    var dEnd = addBusinessDays(now, 5);
    var months = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    var days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    var startStr = days[dStart.getDay()] + ', ' + months[dStart.getMonth()] + ' ' + dStart.getDate();
    var endStr = days[dEnd.getDay()] + ', ' + months[dEnd.getMonth()] + ' ' + dEnd.getDate();
    etaEl.textContent = startStr + ' – ' + endStr;
  }

  function updateCouponUI(cart) {
    var inputRow = document.getElementById('couponFieldRow');
    var appliedCard = document.getElementById('couponAppliedCard');
    var codeDisplay = document.getElementById('couponAppliedCode');
    var savingsDisplay = document.getElementById('couponAppliedSavings');
    var summaryLabel = document.getElementById('couponSummaryLabel');
    var billCouponRow = document.getElementById('billCouponRow');
    var billCouponName = document.getElementById('billCouponName');
    var billCouponDiscount = document.getElementById('billCouponDiscount');

    var originalTotal = (cart && cart.original_total_price != null) ? cart.original_total_price : (cart ? cart.total_price : 0);
    var finalTotal = cart ? cart.total_price : 0;
    var shopifyDiscount = (cart && cart.total_discount != null) ? cart.total_discount : Math.max(0, originalTotal - finalTotal);

    // Extract discount names/codes from Shopify's native cart_level and line_level discount applications
    var discountTitles = [];
    if (cart && cart.cart_level_discount_applications && cart.cart_level_discount_applications.length) {
      cart.cart_level_discount_applications.forEach(function (app) {
        if (app.title && discountTitles.indexOf(app.title) === -1) discountTitles.push(app.title);
      });
    }
    if (cart && cart.items && cart.items.length) {
      cart.items.forEach(function (itm) {
        if (itm.line_level_discount_applications && itm.line_level_discount_applications.length) {
          itm.line_level_discount_applications.forEach(function (app) {
            var t = app.title || (app.discount_application && app.discount_application.title);
            if (t && discountTitles.indexOf(t) === -1) discountTitles.push(t);
          });
        }
        if (itm.discounts && itm.discounts.length) {
          itm.discounts.forEach(function (d) {
            if (d.title && discountTitles.indexOf(d.title) === -1) discountTitles.push(d.title);
          });
        }
      });
    }
    var discountLabel = discountTitles.length > 0 ? discountTitles.join(', ') : (appliedCouponCode || 'Discount');
    var removeBtn = document.getElementById('couponRemoveBtn');
    var couponBox = document.getElementById('cartCouponAccordion');
    var summarySave = document.getElementById('couponSummarySave');

    // Coupon row summary: "<b>BUY2TANKS</b> applied" + "You're saving Rs. X" (Shopify's total_discount)
    function setSummary(code, saveText) {
      if (couponBox) couponBox.classList.toggle('is-applied', !!code);
      if (summarySave) {
        summarySave.hidden = !saveText;
        summarySave.textContent = saveText || '';
      }
      if (!summaryLabel) return;
      summaryLabel.textContent = '';
      if (!code) {
        summaryLabel.textContent = 'Have a coupon code?';
        return;
      }
      var b = document.createElement('b');
      b.textContent = code;
      summaryLabel.appendChild(b);
      summaryLabel.appendChild(document.createTextNode(' applied'));
    }

    if (shopifyDiscount > 0) {
      if (appliedCard) appliedCard.style.display = 'flex';
      if (inputRow) inputRow.style.display = 'none';
      if (codeDisplay) codeDisplay.textContent = discountLabel;
      if (savingsDisplay) savingsDisplay.textContent = '· ' + formatMoney(shopifyDiscount) + ' SAVED';
      setSummary(discountLabel, "You're saving " + formatMoneyShort(shopifyDiscount));
      if (removeBtn) removeBtn.style.display = appliedCouponCode ? 'block' : 'none';

      if (billCouponRow && billCouponName && billCouponDiscount) {
        billCouponRow.style.display = 'flex';
        billCouponName.textContent = discountLabel;
        billCouponDiscount.textContent = '- ' + formatMoneyShort(shopifyDiscount);
      }
    } else if (appliedCouponCode) {
      if (appliedCard) appliedCard.style.display = 'flex';
      if (inputRow) inputRow.style.display = 'none';
      if (codeDisplay) codeDisplay.textContent = appliedCouponCode.toUpperCase();
      if (savingsDisplay) savingsDisplay.textContent = '· Applied at checkout';
      setSummary(appliedCouponCode.toUpperCase(), 'Applies at checkout');

      if (billCouponRow && billCouponName && billCouponDiscount) {
        billCouponRow.style.display = 'flex';
        billCouponName.textContent = appliedCouponCode.toUpperCase();
        billCouponDiscount.textContent = 'Applied at checkout';
      }
    } else {
      if (appliedCard) appliedCard.style.display = 'none';
      if (inputRow) inputRow.style.display = 'flex';
      setSummary('', '');
      if (billCouponRow) billCouponRow.style.display = 'none';
    }
  }

  function applyCoupon(code) {
    if (!code || !code.trim()) return;
    var trimmed = code.trim().toUpperCase();
    appliedCouponCode = trimmed;
    try {
      sessionStorage.setItem('mcx_applied_coupon', trimmed);
      localStorage.setItem('fastrrCouponCode', trimmed);
      document.cookie = 'discount_code=' + encodeURIComponent(trimmed) + '; path=/; max-age=604800; SameSite=Lax';
    } catch (e) {}

    // Persist to Shopify Cart Attributes so backend receives and backs it up
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Discount Code': trimmed } })
    })
      .then(function () {
        var msg = document.getElementById('couponMsg');
        if (msg) {
          msg.textContent = 'Coupon ' + trimmed + ' applied!';
          msg.className = 'coupon-msg is-success';
          msg.style.display = 'block';
          setTimeout(function () { msg.style.display = 'none'; }, 3000);
        }
        refreshCartDrawer();
      })
      .catch(function () {
        refreshCartDrawer();
      });
  }

  function removeCoupon() {
    appliedCouponCode = '';
    try {
      sessionStorage.removeItem('mcx_applied_coupon');
      localStorage.removeItem('fastrrCouponCode');
      document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT; SameSite=Lax';
    } catch (e) {}

    // Clear from Shopify Cart Attributes
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'Discount Code': '' } })
    })
      .then(function () {
        var msg = document.getElementById('couponMsg');
        if (msg) {
          msg.textContent = 'Coupon removed';
          msg.className = 'coupon-msg';
          msg.style.display = 'block';
          setTimeout(function () { msg.style.display = 'none'; }, 2000);
        }
        refreshCartDrawer();
      })
      .catch(function () {
        refreshCartDrawer();
      });
  }

  function goToCheckout(isPrepaid) {
    var checkoutUrl = '/checkout';
    if (appliedCouponCode) {
      checkoutUrl += '?discount=' + encodeURIComponent(appliedCouponCode);
    }
    window.location.href = checkoutUrl;
  }

  function refreshCartDrawer() {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.cart-count').forEach(function (el) {
          el.textContent = cart.item_count;
        });

        var bagCountTitle = document.querySelector('#cart .head strong');
        if (bagCountTitle) bagCountTitle.textContent = 'YOUR BAG (' + cart.item_count + ')';

        var goals = window.ShopifyTheme.cartGoals || {};
        var M2 = Number(goals.m2_threshold) || 2399;
        var totalRs = (cart.total_price || 0) / 100;
        var step2Done = totalRs >= M2;

        updateDeliveryEta();

        // NATIVE SHOPIFY MONETARY VALUES (Single Source of Truth)
        var originalTotalCents = (cart.original_total_price != null) ? cart.original_total_price : cart.total_price;
        var finalTotalCents = cart.total_price;
        var shopifyDiscountCents = (cart.total_discount != null) ? cart.total_discount : Math.max(0, originalTotalCents - finalTotalCents);

        // Subtotal (MRP) is Shopify's original_total_price
        var billSubtotal = document.getElementById('billSubtotal');
        if (billSubtotal) billSubtotal.textContent = formatMoneyShort(originalTotalCents);

        // Update discount breakdown & coupon tag from native Shopify data
        updateCouponUI(cart);

        // Total Amount (COD) is strictly Shopify's authoritative total_price
        var billTotalCod = document.getElementById('billTotalCod');
        if (billTotalCod) billTotalCod.textContent = formatMoneyShort(finalTotalCents);

        // Collapsible Bill Breakup Header Total & Count
        var billItemCount = document.getElementById('billItemCount');
        if (billItemCount) billItemCount.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');

        var billSummaryTotal = document.getElementById('billSummaryTotal');
        if (billSummaryTotal) billSummaryTotal.textContent = formatMoneyShort(finalTotalCents);

        // Bag total left of Buy Now: Shopify's total_price
        var btnCodAmount = document.getElementById('btnCodAmount');
        if (btnCodAmount) btnCodAmount.textContent = formatMoneyShort(finalTotalCents);

        var btnCheckoutItems = document.getElementById('btnCheckoutItems');
        if (btnCheckoutItems) btnCheckoutItems.textContent = cart.item_count + ' item' + (cart.item_count !== 1 ? 's' : '');

        // Prepaid 10% Instant Gateway Benefit: calculated strictly off Shopify's final total_price
        var prepaidSavingsCents = Math.round(finalTotalCents * 0.10);
        var prepaidFinalCents = Math.max(0, finalTotalCents - prepaidSavingsCents);

        var prepaidAmountEl = document.getElementById('prepaidSavingsAmount');
        if (prepaidAmountEl) prepaidAmountEl.textContent = formatMoney(prepaidSavingsCents);

        var prepaidStrikeEl = document.getElementById('prepaidStrikePrice');
        if (prepaidStrikeEl) prepaidStrikeEl.textContent = formatMoney(finalTotalCents);

        var prepaidDiscountedEl = document.getElementById('prepaidDiscountedPrice');
        if (prepaidDiscountedEl) prepaidDiscountedEl.textContent = formatMoney(prepaidFinalCents);

        var btnPrepaidSaveEl = document.getElementById('btnPrepaidSaveAmount');
        if (btnPrepaidSaveEl) btnPrepaidSaveEl.textContent = formatMoney(prepaidSavingsCents);

        // Toggle containers based on cart.item_count
        var hasItems = cart.item_count > 0;
        var etaContainer = document.getElementById('cartDeliveryEta');
        if (etaContainer) etaContainer.style.display = hasItems ? 'flex' : 'none';

        var couponBox = document.getElementById('cartCouponAccordion') || document.getElementById('cartCouponBox');
        if (couponBox) couponBox.style.display = hasItems ? 'block' : 'none';

        var billBreakup = document.getElementById('cartBillBreakup');
        if (billBreakup) billBreakup.style.display = hasItems ? 'block' : 'none';

        var prepaidCard = document.getElementById('cartPrepaidSavings');
        if (prepaidCard) prepaidCard.style.display = hasItems ? 'flex' : 'none';

        // Dynamic Counts: Hoodies, Jeans, Shirts & B1G1 Printed Pants
        var printedPantsCount = 0;
        var hoodiesCount = 0;
        var jeansCount = 0;
        var shirtsCount = 0;
        if (cart.items && cart.items.length) {
          cart.items.forEach(function (itm) {
            var h = (itm.handle || '').toLowerCase();
            var t = (itm.title || itm.product_title || '').toLowerCase();
            var ptype = (itm.product_type || '').toLowerCase();
            var u = (itm.url || '').toLowerCase();
            var qty = Number(itm.quantity) || 1;

            // Hoodie identification (strictly isolated for Winter Deals)
            if (ptype === 'hoodie' || h.indexOf('hoodie') !== -1 || t.indexOf('hoodie') !== -1 || u.indexOf('hoodie') !== -1) {
              hoodiesCount += qty;
              return;
            }

            // Jeans identification (strictly isolated for Denim Tier)
            if (ptype.indexOf('jean') !== -1 || h.indexOf('jean') !== -1 || t.indexOf('jean') !== -1 || u.indexOf('jean') !== -1 || h.indexOf('denim') !== -1 || t.indexOf('denim') !== -1) {
              jeansCount += qty;
              return;
            }

            // Shirts identification (strictly isolated for Shirts Tier, distinguishing from tees)
            var isTee = ptype.indexOf('tee') !== -1 || h.indexOf('tee') !== -1 || t.indexOf('tee') !== -1 || t.indexOf('t-shirt') !== -1;
            if (!isTee && (ptype.indexOf('shirt') !== -1 || h.indexOf('shirt') !== -1 || t.indexOf('shirt') !== -1 || h.indexOf('clasp') !== -1 || t.indexOf('clasp') !== -1)) {
              shirtsCount += qty;
              return;
            }

            if (h.indexOf('bundle') !== -1 || h.indexOf('combo') !== -1 || t.indexOf('bundle') !== -1 || t.indexOf('combo') !== -1 || t.indexOf('mystery') !== -1) return;
            if (h.indexOf('toji') !== -1 || h.indexOf('togi') !== -1 || t.indexOf('toji') !== -1 || t.indexOf('togi') !== -1 || h.indexOf('basic-') === 0) return;
            if (h.indexOf('vest') !== -1 || h.indexOf('tank') !== -1 || h.indexOf('tee') !== -1 || t.indexOf('vest') !== -1 || t.indexOf('tank') !== -1 || t.indexOf('tee') !== -1) return;

            if (grungeSingleHandles.indexOf(h) !== -1) {
              printedPantsCount += qty;
            }
          });
        }

        var prepaidSticker = document.getElementById('btnPrepaidSticker');
        if (prepaidSticker) {
          if (hoodiesCount >= 3) {
            prepaidSticker.textContent = '3 FOR ₹3,599 APPLIED';
          } else if (hoodiesCount === 2) {
            prepaidSticker.textContent = '2 FOR ₹2,999 APPLIED';
          } else if (printedPantsCount >= 2) {
            prepaidSticker.textContent = 'B1G1 PREPAID FREE';
          } else if (jeansCount >= 3 || shirtsCount >= 3) {
            prepaidSticker.textContent = '30% OFF + 10% PREPAID';
          } else if (jeansCount === 2 || shirtsCount === 2) {
            prepaidSticker.textContent = '20% OFF + 10% PREPAID';
          } else {
            prepaidSticker.textContent = '10% PREPAID OFF';
          }
        }

        ['cartBuyTotal', 'btnPrepaidSticker', 'cartTrustRow'].forEach(function (id) {
          var el = document.getElementById(id);
          if (el) el.hidden = !hasItems;
        });

        var cartForm = document.getElementById('CartDrawer-Form');
        if (cartForm) cartForm.style.display = hasItems ? 'block' : 'none';

        // Render Cart Items
        var listContainer = document.querySelector('#cart .cart-items-container');
        if (listContainer) {
          if (cart.item_count === 0) {
            listContainer.innerHTML = '<p class="muted sm" style="text-align:center;padding:40px 0;">Your bag is currently empty.</p>';
          } else {
            var html = '';

            // If unlocked at ₹2,399+, render generic Free Gift line item matching customer size
            if (step2Done) {
              var custSize = getCustomerCartSize(cart);
              var giftTitle = goals.gift_title || 'Free Baggy Pant - Prepaid Gift';
              var giftImg = goals.gift_image || 'https://cdn.shopify.com/s/files/1/0736/5836/8222/files/soild.png?v=1760605300';
              var giftPriceStrike = goals.gift_original_price || 'Rs. 1,599';
              var giftProductId = goals.gift_product_id || '9322235330782';
              var giftVariantId = goals.gift_variant_id || '48651699454174';

              html += '<div class="line cart-item-card free-gift-line" id="freeGiftLineItem" data-free-gift="true" data-product-id="' + giftProductId + '" data-variant-id="' + giftVariantId + '">' +
                '<div class="ph r45 cart-item-thumb has-img">' +
                  '<img src="' + giftImg + '" alt="' + giftTitle + '" loading="lazy" width="50" height="62">' +
                '</div>' +
                '<div class="cart-item-details">' +
                  '<div class="free-gift-badge-row">' +
                    '<span class="free-gift-pill">FREE GIFT</span>' +
                    '<span class="free-gift-tag">Prepaid Unlock</span>' +
                  '</div>' +
                  '<h4 class="cart-item-title">' + giftTitle + '</h4>' +
                  '<p class="cart-item-variant">Size: ' + custSize + '</p>' +
                  '<div class="cart-item-actions">' +
                    '<span class="free-gift-qty-badge">Qty: 1</span>' +
                    '<div class="free-gift-price-row">' +
                      '<s class="muted xs">' + giftPriceStrike + '</s>' +
                      '<span class="free-gift-price">₹0</span>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>';
            }

            cart.items.forEach(function (item, index) {
              var imgUrl = item.image || '';
              // "Size: XL" (or "Size: XL · Color: Black")
              var optionsText = item.product_has_only_default_variant ? '' : (item.options_with_values || []).map(function (o) {
                return o.name + ': ' + o.value;
              }).join(' · ') || item.variant_title || '';
              html += '<div class="line cart-item-card" data-line-key="' + item.key + '">' +
                '<div class="ph r45 cart-item-thumb' + (imgUrl ? ' has-img' : '') + '">' +
                  (imgUrl ? '<img src="' + imgUrl + '" alt="' + (item.title || '') + '" loading="lazy" width="112" height="140">' : '') +
                '</div>' +
                '<div class="cart-item-details">' +
                  '<h4 class="cart-item-title">' + item.product_title + '</h4>' +
                  (optionsText ? '<p class="cart-item-variant">' + optionsText + '</p>' : '') +
                  '<div class="cart-item-actions">' +
                    '<div class="qty cart-qty-pill">' +
                      '<button type="button" data-qty-change="-1" data-line="' + (index + 1) + '" aria-label="Decrease quantity">−</button>' +
                      '<span>' + item.quantity + '</span>' +
                      '<button type="button" data-qty-change="1" data-line="' + (index + 1) + '" aria-label="Increase quantity">+</button>' +
                    '</div>' +
                    '<div class="cart-item-pricing">' +
                      // Deal lines wait for applyLinePrices so Shopify's even split doesn't flash first
                      '<span class="cart-item-price' + (item.final_line_price < item.original_line_price ? ' is-pending' : '') + '">' + formatMoneyShort(item.final_line_price) + '</span>' +
                      '<button type="button" class="cart-remove-item" data-line-remove="' + (index + 1) + '" aria-label="Remove ' + item.title + '">Remove</button>' +
                    '</div>' +
                  '</div>' +
                '</div>' +
              '</div>';
            });
            listContainer.innerHTML = html;
          }
        }

        if (typeof window.removeNativeButton === 'function') {
          try { window.removeNativeButton(); } catch (e) {}
        }

        refreshCartSections();
      })
      .catch(function (err) {
        console.warn('Cart refresh warning:', err);
      });
  }

  // Server-rendered drawer parts (Section Rendering API): savings line, deal bar, deal rail.
  // Compare-at savings, collection membership and applied discounts need Liquid (not in /cart.js).
  // Skipped on the page-load refresh — Liquid already rendered them for the current cart.
  var cartSectionsPrimed = false;
  function refreshCartSections() {
    if (!document.getElementById('cartSavings') && !document.getElementById('cartDealBar')) {
      applyLinePrices(false);
      return;
    }
    if (!cartSectionsPrimed) {
      cartSectionsPrimed = true;
      applyLinePrices();
      applySecretDeal();
      return;
    }
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    fetch(root + '?sections=cart-savings,cart-offers')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (!data) return;
        var temp = document.createElement('div');
        temp.innerHTML = (data['cart-savings'] || '') + (data['cart-offers'] || '');
        var oldBar = document.getElementById('cartDealBar');
        var oldUnlocked = oldBar ? (oldBar.getAttribute('data-unlocked') || '').split(',') : [];
        var oldSavingsEl = document.getElementById('cartSavings');
        var oldSaved = oldSavingsEl ? parseInt(oldSavingsEl.getAttribute('data-saved'), 10) || 0 : 0;
        ['cartSavings', 'cartDealBar', 'cartSurprise', 'cartDealRail'].forEach(function (id) {
          var current = document.getElementById(id);
          var fresh = temp.querySelector('#' + id);
          if (current && fresh) current.replaceWith(fresh);
        });
        applyLinePrices();
        applySecretDeal();
        // Celebrate a newly unlocked tier / free pant goal
        var newBar = document.getElementById('cartDealBar');
        var newUnlocked = newBar ? (newBar.getAttribute('data-unlocked') || '').split(',') : [];
        if (newUnlocked.some(function (k) { return k && oldUnlocked.indexOf(k) === -1; })) triggerMilestoneConfetti();

        // Savings feel like earning: "+Rs. 399 saved" when Shopify's savings for this bag go up
        var newSavingsEl = document.getElementById('cartSavings');
        var newSaved = newSavingsEl ? parseInt(newSavingsEl.getAttribute('data-saved'), 10) || 0 : 0;
        if (newSaved > oldSaved) showSavingsToast(newSaved - oldSaved);
      })
      .catch(function (err) {
        applyLinePrices(false);
        console.warn('Cart sections refresh warning:', err);
      });
  }

  // Deal line prices from Liquid (snippets/cart-line-prices.liquid, on #cartDealBar): the 1st deal item at full
  // price, each next one at what it added to the bag, full price struck. Lines without an entry keep Shopify's
  // price; useMap false just reveals Shopify's prices (bar missing or stale).
  function applyLinePrices(useMap) {
    var bar = document.getElementById('cartDealBar');
    var map = {};
    if (useMap !== false && bar) {
      (bar.getAttribute('data-line-prices') || '').split(';').forEach(function (pair) {
        var i = pair.lastIndexOf('=');
        if (i > 0) map[pair.slice(0, i)] = pair.slice(i + 1).split(',').map(Number);
      });
    }
    document.querySelectorAll('.cart-item-card[data-line-key]').forEach(function (card) {
      var priceEl = card.querySelector('.cart-item-price');
      if (!priceEl) return;
      var p = map[card.getAttribute('data-line-key')];
      var was = card.querySelector('.cart-item-was');
      if (p && !isNaN(p[0]) && !isNaN(p[1])) {
        priceEl.textContent = formatMoneyShort(p[0]);
        if (p[0] < p[1]) {
          if (!was) {
            was = document.createElement('s');
            was.className = 'cart-item-was';
            priceEl.parentNode.insertBefore(was, priceEl);
          }
          was.textContent = formatMoneyShort(p[1]);
        } else if (was) {
          was.remove();
        }
      }
      priceEl.classList.remove('is-pending');
    });
  }

  // Secret Deal (snippets/cart-surprise.liquid): applies Liquid's line fixes (1 secret pant per order,
  // removed when alone in the bag) and runs the reveal + session timer. The shopper earns the deal:
  // taps 1–2 zap the wand and charge the box, tap 3 casts the spell (swirl + sparkle trail, flash,
  // confetti), then the deal pops in with prices counting down and a 10-minute timer starts.
  // Re-renders restore the revealed state instantly; once the timer runs out the deal stays hidden
  // for the session.
  var SECRET_MINUTES = 10;
  var SECRET_TAPS = 3;
  var SECRET_CAST_MS = 1400;  // wand swirl
  var SECRET_BURST_MS = 380;  // flash + shockwave before the deal pops in
  var secretFixing = false;
  var secretTimerId = null;

  var secretEndsMem = 0; // fallback when sessionStorage is blocked
  // Key renamed from 'mcxSecretEnds' (first version auto-started the timer on drawer open, without a tap)
  var SECRET_KEY = 'mcxSecretRevealEnds';

  function secretEnds() {
    try { return parseInt(sessionStorage.getItem(SECRET_KEY), 10) || secretEndsMem; } catch (e) { return secretEndsMem; }
  }

  function applySecretDeal() {
    var box = document.getElementById('cartSurprise');
    if (!box) return;

    var fix = {};
    try { fix = JSON.parse(box.getAttribute('data-fix') || '{}'); } catch (e) {}
    if (Object.keys(fix).length && !secretFixing) {
      secretFixing = true;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: fix })
      })
        .then(function () { refreshCartDrawer(); })
        .catch(function () {})
        .then(function () { secretFixing = false; });
    }

    if (box.hasAttribute('hidden')) return;
    var ends = secretEnds();
    if (ends && Date.now() >= ends) {
      box.setAttribute('hidden', '');
      return;
    }
    if (ends) showSecretPanel(box); // already revealed this session: no teaser, no wand
  }

  function showSecretPanel(box) {
    var teaser = box.querySelector('[data-secret-reveal]');
    var panel = box.querySelector('.xs-panel');
    if (teaser) teaser.hidden = true;
    if (panel) panel.hidden = false;
    box.classList.add('is-revealed');
    tickSecretTimer(); // set the time before paint, so it never flashes a stale value
    if (!secretTimerId) secretTimerId = setInterval(tickSecretTimer, 1000);
  }

  function tickSecretTimer() {
    var box = document.getElementById('cartSurprise');
    var ends = secretEnds();
    if (!box || box.hasAttribute('hidden') || !ends) return;
    var left = Math.max(0, Math.ceil((ends - Date.now()) / 1000));
    var label = Math.floor(left / 60) + ':' + ('0' + (left % 60)).slice(-2);
    box.querySelectorAll('[data-secret-timer]').forEach(function (el) { el.textContent = label; });
    if (left <= 0) box.setAttribute('hidden', '');
  }

  function secretBuzz(pattern) {
    try { if (navigator.vibrate) navigator.vibrate(pattern); } catch (e) {}
  }

  // Sparkle dust around (x, y) inside the box; defaults to the wand's star tip
  function secretDust(box, count, x, y) {
    var br = box.getBoundingClientRect();
    if (x == null) {
      var wand = box.querySelector('.xs-wand');
      var wr = wand ? wand.getBoundingClientRect() : null;
      if (wr && wr.width) {
        x = wr.left - br.left + wr.width * 0.75;
        y = wr.top - br.top + wr.height * 0.25;
      } else {
        x = br.width * 0.8;
        y = br.height * 0.5;
      }
    }
    for (var i = 0; i < count; i++) {
      var d = document.createElement('i');
      d.className = 'xs-dust' + (i % 3 === 0 ? ' xs-dust--alt' : '');
      d.textContent = i % 3 === 0 ? '✨' : '✦';
      d.setAttribute('aria-hidden', 'true');
      var a = Math.random() * Math.PI * 2;
      var r = 18 + Math.random() * 42;
      d.style.left = x + 'px';
      d.style.top = y + 'px';
      d.style.setProperty('--dx', Math.round(Math.cos(a) * r) + 'px');
      d.style.setProperty('--dy', Math.round(Math.sin(a) * r) + 'px');
      d.style.setProperty('--sz', (8 + Math.random() * 9).toFixed(1) + 'px');
      box.appendChild(d);
      setTimeout(d.remove.bind(d), 800);
    }
  }

  // Count prices down (e.g. Rs. 1,299 → Rs. 499) so the shopper sees the drop happen
  function secretTickPrices(box) {
    box.querySelectorAll('[data-tick-to]').forEach(function (el) {
      var from = parseInt(el.getAttribute('data-tick-from'), 10) || 0;
      var to = parseInt(el.getAttribute('data-tick-to'), 10) || 0;
      if (!from || from <= to) return;
      var t0 = null;
      var dur = 1100;
      el.classList.add('is-ticking');
      function step(now) {
        if (t0 === null) t0 = now;
        var p = Math.min(1, (now - t0) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = 'Rs. ' + Math.round(from + (to - from) * eased).toLocaleString('en-IN');
        if (p < 1) {
          requestAnimationFrame(step);
        } else {
          el.classList.remove('is-ticking');
          el.classList.add('is-landed');
        }
      }
      el.textContent = 'Rs. ' + from.toLocaleString('en-IN');
      requestAnimationFrame(step);
    });
  }

  function revealSecret(box, animate) {
    secretEndsMem = Date.now() + SECRET_MINUTES * 60000;
    try { sessionStorage.setItem(SECRET_KEY, String(secretEndsMem)); } catch (e) {}
    box.classList.remove('is-casting', 'is-burst', 'is-zap');
    showSecretPanel(box);
    if (!animate) return;
    box.classList.add('is-just-revealed'); // pop-in plays only on the reveal, not on later re-renders
    var title = box.querySelector('[data-secret-title]');
    if (title) title.textContent = 'You earned it! 🎉';
    secretTickPrices(box);
  }

  function castSecret(box) {
    box.classList.remove('is-zap');
    box.classList.add('is-casting');
    var trail = setInterval(function () { secretDust(box, 3); }, 55);
    setTimeout(function () {
      clearInterval(trail);
      var live = document.getElementById('cartSurprise'); // the box may have been re-rendered meanwhile
      if (!live || live.hidden) return;
      live.classList.add('is-burst');
      var br = live.getBoundingClientRect();
      secretDust(live, 26, br.width / 2, br.height / 2);
      secretBuzz([40, 40, 90]);
      if (typeof triggerMilestoneConfetti === 'function') triggerMilestoneConfetti();
      setTimeout(function () {
        var now = document.getElementById('cartSurprise');
        if (now && !now.hidden) revealSecret(now, true);
      }, SECRET_BURST_MS);
    }, SECRET_CAST_MS);
  }

  document.addEventListener('click', function (e) {
    var teaser = e.target.closest('[data-secret-reveal]');
    if (!teaser) return;
    e.preventDefault();
    var box = teaser.closest('#cartSurprise');
    if (!box || box.classList.contains('is-casting')) return;

    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) {
      revealSecret(box, false);
      return;
    }

    var taps = (parseInt(box.getAttribute('data-charges'), 10) || 0) + 1;
    box.setAttribute('data-charges', String(taps));
    var label = box.querySelector('[data-secret-tap-label]');
    if (taps < SECRET_TAPS) {
      if (label) label.textContent = (SECRET_TAPS - taps) + ' more';
      box.classList.remove('is-zap');
      void box.offsetWidth; // restart the zap animation
      box.classList.add('is-zap');
      secretBuzz(15);
      setTimeout(function () { secretDust(box, 10 + taps * 6); }, 160);
      return;
    }
    if (label) label.textContent = 'Casting…';
    secretBuzz([20, 30, 20, 30, 20]);
    castSecret(box);
  });

  function showSavingsToast(cents) {
    var drawer = document.getElementById('cart');
    if (!drawer) return;
    var old = drawer.querySelector('.xd-toast');
    if (old) old.remove();
    var toast = document.createElement('div');
    toast.className = 'xd-toast';
    toast.setAttribute('role', 'status');
    toast.textContent = '+' + formatMoney(cents).replace(/\.00$/, '') + ' saved 🎉';
    drawer.appendChild(toast);
    setTimeout(function () { toast.remove(); }, 2200);
  }

  function addToCart(variantId, quantity, buttonEl) {
    if (!variantId) return;
    var prevText = '';
    if (buttonEl) {
      buttonEl.disabled = true;
      prevText = buttonEl.textContent;
      buttonEl.textContent = 'Adding...';
    }

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    })
      .then(function (res) {
        if (!res.ok) throw new Error('Add to cart failed');
        return res.json();
      })
      .then(function () {
        refreshCartDrawer();
        openDrawer('cart');
      })
      .catch(function (err) {
        console.error('Add to cart error:', err);
      })
      .finally(function () {
        if (buttonEl) {
          buttonEl.disabled = false;
          buttonEl.textContent = prevText;
        }
      });
  }

  window.addToCart = addToCart;
  window.refreshCartDrawer = refreshCartDrawer;

  function initCartHandlers() {
    // Quick Add
    document.addEventListener('click', function (e) {
      var qaBtn = e.target.closest('[data-quick-add]');
      if (qaBtn) {
        e.preventDefault();
        var variantId = qaBtn.getAttribute('data-quick-add');
        addToCart(variantId, 1, qaBtn);
      }
    });

    // Coupon Code Apply & Remove
    document.addEventListener('click', function (e) {
      if (e.target && e.target.id === 'CartCouponApplyBtn') {
        e.preventDefault();
        var input = document.getElementById('CartCouponInput');
        if (input && input.value) {
          applyCoupon(input.value);
        }
      }
      if (e.target && (e.target.id === 'couponRemoveBtn' || e.target.closest('#couponRemoveBtn'))) {
        e.preventDefault();
        removeCoupon();
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.target && e.target.id === 'CartCouponInput' && e.key === 'Enter') {
        e.preventDefault();
        applyCoupon(e.target.value);
      }
    });

    // Checkout CTA — Prioritize Shiprocket Fastrr 1-Click Checkout with zero-drop Native Fallback
    document.addEventListener('click', function (e) {
      var checkoutBtn = e.target.closest('#CartDrawer-Checkout, #CartDrawer-PrepaidCheckout');
      if (checkoutBtn) {
        // 1. If Shiprocket Fastrr checkout is ready, trigger it directly (Captures mobile for SR Engage recovery)
        if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyCart === 'function') {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          window.shiprocketCheckoutEvents.buyCart(e);
          return;
        }
        if (window.HeadlessCheckout && typeof window.HeadlessCheckout.checkout === 'function') {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          window.HeadlessCheckout.checkout(e);
          return;
        }

        // 2. Conversion Safeguard Fallback: If Shiprocket is unavailable or blocked, proceed to native checkout
        if (appliedCouponCode) {
          e.preventDefault();
          goToCheckout(false);
        }
      }
    }, true);

    // Quantity changers
    document.addEventListener('click', function (e) {
      var qtyBtn = e.target.closest('[data-qty-change]');
      if (qtyBtn) {
        e.preventDefault();
        var delta = parseInt(qtyBtn.getAttribute('data-qty-change'), 10);
        var line = parseInt(qtyBtn.getAttribute('data-line'), 10);
        var spanEl = qtyBtn.parentNode ? qtyBtn.parentNode.querySelector('span') : null;
        var currentQty = spanEl ? parseInt(spanEl.textContent, 10) : 1;
        var newQty = Math.max(0, currentQty + delta);

        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: newQty })
        })
          .then(function () { refreshCartDrawer(); })
          .catch(function (err) { console.error('Cart change error:', err); });
      }
    });

    // Line remove
    document.addEventListener('click', function (e) {
      var rmBtn = e.target.closest('[data-line-remove]');
      if (rmBtn) {
        e.preventDefault();
        var line = parseInt(rmBtn.getAttribute('data-line-remove'), 10);
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ line: line, quantity: 0 })
        })
          .then(function () { refreshCartDrawer(); })
          .catch(function (err) { console.error('Cart remove error:', err); });
      }
    });

    // Order Note Save
    document.addEventListener('change', function (e) {
      if (e.target && e.target.id === 'CartDrawer-Note') {
        fetch('/cart/update.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ note: e.target.value })
        });
      }
    });
  }

  /* ============================================================
     PDP: DYNAMIC MULTI-OPTION & OFFER CARDS & PINCODE
     ============================================================ */
  function initProductPage() {
    var pdp = document.querySelector('.pdp');
    if (!pdp) return;

    var productForm = document.getElementById('product-form');
    var variantInput = document.getElementById('selected-variant-id');
    var qtyInput = document.getElementById('product-quantity');
    var priceNow = document.querySelector('.pprice .now');
    var priceWas = document.querySelector('.pprice .was');
    var priceOff = document.querySelector('.pprice .off');
    var addBtn = document.getElementById('addBtn');
    var satcBtn = document.getElementById('satcBtn') || document.querySelector('.satc .btn');
    var satcNow = document.querySelector('.satc .now');
    var satcWas = document.querySelector('.satc .was');
    var satcVariant = document.getElementById('satcVariant');
    var pmetaStock = document.querySelector('.pmeta span[style*="color"]');
    var pmetaSku = document.querySelector('.pmeta .muted.sm');
    var galTrack = document.querySelector('.gal .track');

    // Retrieve Product Data JSON
    var productData = window.ProductData;
    if (!productData) {
      var jsonScript = document.getElementById('ProductJson-main') || document.querySelector('[id^="ProductJson-"]');
      if (jsonScript) {
        try {
          productData = JSON.parse(jsonScript.textContent);
          window.ProductData = productData;
        } catch (e) {
          console.warn('Could not parse Product JSON:', e);
        }
      }
    }

    var optionRows = document.querySelectorAll('.optrow[data-option-index]');

    function getSelectedOptions() {
      var selected = [];
      var hasUnselectedRequiredOption = false;
      optionRows.forEach(function (row, idx) {
        var isSizeRow = row.getAttribute('data-is-size') === 'true' || /size|waist|sizing/i.test(row.getAttribute('data-option-name') || '');
        var activeBtn = row.querySelector('button[aria-pressed="true"]');
        if (!activeBtn && !isSizeRow) {
          activeBtn = row.querySelector('button[data-option-value]');
          if (activeBtn) activeBtn.setAttribute('aria-pressed', 'true');
        }
        if (activeBtn) {
          var val = activeBtn.getAttribute('data-option-value');
          var rowIdx = parseInt(row.getAttribute('data-option-index'), 10);
          if (isNaN(rowIdx)) rowIdx = idx;
          selected[rowIdx] = val;
          var labelVal = row.querySelector('.selected-val');
          if (labelVal) labelVal.textContent = val;
        } else if (isSizeRow) {
          hasUnselectedRequiredOption = true;
          var labelVal = row.querySelector('.selected-val');
          if (labelVal) labelVal.textContent = 'Select size';
        }
      });
      return { selected: selected, hasUnselected: hasUnselectedRequiredOption };
    }

    function updateVariant() {
      if (!productData || !productData.variants || !productData.variants.length) return;
      var optionState = getSelectedOptions();
      var selected = optionState.selected;

      // If user hasn't selected a size yet, don't lock into an accidental size
      if (optionState.hasUnselected) {
        if (variantInput) variantInput.value = '';
        document.querySelectorAll('#product-form input[name="id"]').forEach(function (inp) {
          inp.value = '';
        });
        if (addBtn) {
          addBtn.disabled = false;
          var firstAvailable = productData.variants.find(function (v) { return v.available; }) || productData.variants[0];
          addBtn.textContent = 'Add to bag — ' + formatMoney(firstAvailable.price);
        }
        if (satcBtn) {
          satcBtn.disabled = false;
          satcBtn.textContent = 'ADD TO BAG';
        }
        if (satcVariant) satcVariant.textContent = 'Select size';
        if (pmetaStock) {
          pmetaStock.textContent = 'Select a size';
          pmetaStock.style.color = 'var(--c-ash)';
        }
        return;
      }

      var matchedVariant = productData.variants.find(function (v) {
        for (var i = 0; i < selected.length; i++) {
          var targetVal = cleanVal(selected[i]);
          if (!targetVal) return false;
          var vOpt = (v.options && v.options[i] != null) ? v.options[i] : v['option' + (i + 1)];
          if (cleanVal(vOpt) !== targetVal) {
            return false;
          }
        }
        return true;
      });

      if (!matchedVariant && productData.variants.length > 0 && !optionState.hasUnselected) {
        matchedVariant = productData.variants[0];
      }

      if (matchedVariant) {
        // 1. Update hidden inputs
        if (variantInput) variantInput.value = matchedVariant.id;
        document.querySelectorAll('#product-form input[name="id"]').forEach(function (inp) {
          inp.value = matchedVariant.id;
        });

        if (satcVariant && matchedVariant.title !== 'Default Title') satcVariant.textContent = matchedVariant.title;

        // 2. Update prices
        var formattedPrice = formatMoney(matchedVariant.price);
        if (priceNow) {
          priceNow.textContent = formattedPrice;
          priceNow.setAttribute('data-price', matchedVariant.price);
        }
        if (satcNow) satcNow.textContent = formattedPrice;

        if (matchedVariant.compare_at_price > matchedVariant.price) {
          var formattedCompare = formatMoney(matchedVariant.compare_at_price);
          if (priceWas) {
            priceWas.textContent = formattedCompare;
            priceWas.style.display = '';
          }
          if (satcWas) {
            satcWas.textContent = formattedCompare;
            satcWas.style.display = '';
          }
          if (priceOff) {
            var discount = Math.round(((matchedVariant.compare_at_price - matchedVariant.price) / matchedVariant.compare_at_price) * 100);
            priceOff.textContent = discount + '% off';
            priceOff.style.display = 'inline-block';
          }
        } else {
          if (priceWas) priceWas.style.display = 'none';
          if (satcWas) satcWas.style.display = 'none';
          if (priceOff) priceOff.style.display = 'none';
        }

        // 3. Availability & Button text
        if (!matchedVariant.available) {
          if (addBtn) { addBtn.disabled = true; addBtn.textContent = 'Sold out'; }
          if (satcBtn) { satcBtn.disabled = true; satcBtn.textContent = 'SOLD OUT'; }
          if (pmetaStock) {
            pmetaStock.textContent = 'Sold Out';
            pmetaStock.style.color = 'var(--c-red)';
          }
        } else {
          // Dynamic calculation of offer boxes for this variant price
          updateOfferBoxes(matchedVariant.price);

          if (addBtn) { addBtn.disabled = false; addBtn.textContent = 'Add to bag — ' + formattedPrice; }
          if (satcBtn) { satcBtn.disabled = false; satcBtn.textContent = 'ADD TO BAG'; }
          if (satcNow) satcNow.textContent = formattedPrice;

          if (pmetaStock) {
            pmetaStock.textContent = 'In Stock';
            pmetaStock.style.color = '#2ecc71';
          }
        }

        // 4. SKU
        if (pmetaSku) {
          pmetaSku.textContent = matchedVariant.sku ? 'SKU ' + matchedVariant.sku : '';
        }

        // 5. Update browser URL history
        if (window.history && window.history.replaceState) {
          var newUrl = window.location.pathname + '?variant=' + matchedVariant.id;
          window.history.replaceState({ path: newUrl }, '', newUrl);
        }

        // 6. Gallery sync
        if (galTrack) {
          var targetMediaId = matchedVariant.featured_media ? matchedVariant.featured_media.id : (matchedVariant.featured_image ? matchedVariant.featured_image.id : null);
          if (targetMediaId) {
            var slide = galTrack.querySelector('[data-media-id="' + targetMediaId + '"]');
            if (slide) {
              slide.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          }
        }
      }
    }

    // Dynamic offer calculations for 2 pcs (20% off + 10% prepaid upto 128) & 3 pcs (30% off + 10% prepaid upto 128)
    function formatRupees(amount) {
      if (amount == null || isNaN(amount)) return '';
      return '₹' + Number(Math.round(amount)).toLocaleString('en-IN');
    }

    function updateOfferBoxes(variantPriceInPaise) {
      var unitPrice = Math.round(variantPriceInPaise / 100);
      var boxes = document.querySelectorAll('.offer-box');
      if (!boxes.length) return;

      boxes.forEach(function (box) {
        if (box.hasAttribute('data-manual-override')) return;
        var offerMode = box.getAttribute('data-offer-mode') || 'auto';
        var qty = parseInt(box.getAttribute('data-qty'), 10) || 2;
        var regTotal = unitPrice * qty;

        var finalPrice, savedAmt, perPiece, subText, saveText;

        if (offerMode === 'b1g1') {
          qty = 2;
          finalPrice = unitPrice;
          savedAmt = unitPrice;
          perPiece = Math.round(unitPrice / 2);
          subText = 'Prepaid Exclusive · 2nd Pant Free';
          saveText = 'FREE 2ND PAIR';
        } else {
          var offPct = qty === 2 ? 0.20 : (qty === 3 ? 0.30 : 0);
          var offPrice = Math.round(regTotal * (1 - offPct));
          var prepaidDisc = Math.min(128, Math.round(offPrice * 0.10));
          finalPrice = offPrice - prepaidDisc;
          savedAmt = regTotal - finalPrice;
          perPiece = Math.round(finalPrice / qty);
          subText = (qty === 2 ? '20%' : '30%') + ' off + 10% prepaid';
          saveText = 'SAVE ' + formatRupees(savedAmt);
        }

        var formattedFinal = formatRupees(finalPrice);
        var formattedPerPiece = formatRupees(perPiece);

        var saveBadge = box.querySelector('.obadge--save');
        if (saveBadge) saveBadge.textContent = saveText;

        var priceEl = box.querySelector('.offer-price');
        if (priceEl) priceEl.textContent = formattedFinal;

        var greenEl = box.querySelector('.offer-green');
        if (greenEl) greenEl.textContent = formattedPerPiece + ' / Piece';

        var subEl = box.querySelector('.offer-sub');
        if (subEl) subEl.textContent = subText;

        box.setAttribute('data-calculated-price', formattedFinal);
        box.setAttribute('data-calculated-amount', finalPrice);
      });
    }

    // Option change click handlers
    optionRows.forEach(function (row) {
      row.querySelectorAll('button[data-option-value]').forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          row.querySelectorAll('button[data-option-value]').forEach(function (b) {
            b.setAttribute('aria-pressed', 'false');
          });
          btn.setAttribute('aria-pressed', 'true');
          var labelVal = row.querySelector('.selected-val');
          if (labelVal) labelVal.textContent = btn.getAttribute('data-option-value');
          
          // Clear validation notice & attention state
          var notice = document.getElementById('sizeRequiredNotice');
          if (notice) notice.style.display = 'none';
          row.classList.remove('pulse-attention');

          updateVariant();
        });
      });
    });

    // Validation helper: Ensure size is selected before purchase
    function validateSizeSelected() {
      var sizeRow = document.querySelector('.optrow--size') || document.querySelector('.optrow[data-is-size="true"]') || (document.querySelector('.sizes') ? document.querySelector('.sizes').closest('.optrow') : null);
      if (!sizeRow) return true; // No size options on product
      var selectedSizeBtn = sizeRow.querySelector('button[aria-pressed="true"]');
      if (!selectedSizeBtn) {
        sizeRow.scrollIntoView({ behavior: 'smooth', block: 'center' });
        sizeRow.classList.add('pulse-attention');
        var notice = document.getElementById('sizeRequiredNotice');
        if (notice) notice.style.display = 'flex';
        setTimeout(function () {
          sizeRow.classList.remove('pulse-attention');
        }, 1200);
        return false;
      }
      return true;
    }

    // Add to Bag validation check
    if (addBtn) {
      addBtn.addEventListener('click', function (e) {
        if (!validateSizeSelected()) {
          e.preventDefault();
          e.stopPropagation();
          return false;
        }
      });
    }

    // Fastrr / Buy Now express checkout button validation & trigger
    var buyNowWrap = document.querySelector('.pdp-buy-now-wrap');
    if (buyNowWrap) {
      buyNowWrap.addEventListener('click', function (e) {
        if (!validateSizeSelected()) {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          return false;
        }

        // 1. If Shiprocket Fastrr express checkout is ready, trigger it directly
        if (window.shiprocketCheckoutEvents && typeof window.shiprocketCheckoutEvents.buyProduct === 'function') {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          window.shiprocketCheckoutEvents.buyProduct(e);
          return false;
        }
        if (window.HeadlessCheckout && typeof window.HeadlessCheckout.buyNow === 'function') {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          window.HeadlessCheckout.buyNow(e);
          return false;
        }

        // 2. Fallback: allow Shopify dynamic payment button to proceed natively
      }, true); // capturing phase
    }

    // Run initial variant sync
    updateVariant();

    // Pincode check — Dynamic 5-8 days delivery from current date (Shipping Policy)
    var pinGo = document.getElementById('pinGo');
    var pinIn = document.getElementById('pinIn');
    var pinOut = document.getElementById('pinOut');

    function checkPincode() {
      if (!pinIn || !pinOut) return;
      var val = pinIn.value.trim();
      if (val.length === 6 && /^[0-9]{6}$/.test(val)) {
        var now = new Date();
        var start = new Date(now.getTime() + 5 * 24 * 60 * 60 * 1000);
        var end = new Date(now.getTime() + 8 * 24 * 60 * 60 * 1000);
        var opts = { weekday: 'short', day: 'numeric', month: 'short' };
        var rangeStr = start.toLocaleDateString('en-IN', opts) + ' – ' + end.toLocaleDateString('en-IN', opts);

        var dateEl = pinOut.querySelector('.pin-date');
        if (dateEl) dateEl.textContent = rangeStr;
        pinOut.classList.add('on');
      } else {
        alert('Please enter a valid 6-digit Indian PIN code.');
      }
    }

    if (pinGo) {
      pinGo.addEventListener('click', function (e) {
        e.preventDefault();
        checkPincode();
      });
    }

    if (pinIn) {
      pinIn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') {
          e.preventDefault();
          checkPincode();
        }
      });
    }

    // Gallery counter & Thumbnail Navigation
    var galCounter = document.querySelector('.gal .counter');
    var galThumbs = document.querySelectorAll('.gal-thumb');

    if (galTrack) {
      var totalSlides = galTrack.children.length;

      // Update counter and thumbnails on gallery scroll
      galTrack.addEventListener('scroll', function () {
        var idx = Math.round(galTrack.scrollLeft / galTrack.clientWidth);
        if (galCounter) {
          galCounter.textContent = Math.min(idx + 1, totalSlides) + ' / ' + totalSlides;
        }

        // Sync active thumbnail
        if (galThumbs.length > 0) {
          galThumbs.forEach(function (thumb, tIdx) {
            var isCurrent = tIdx === idx;
            thumb.classList.toggle('is-active', isCurrent);
            thumb.setAttribute('aria-selected', isCurrent ? 'true' : 'false');
            if (isCurrent) {
              thumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
            }
          });
        }
      }, { passive: true });

      // Thumbnail click listener -> scroll main gallery to clicked photo
      if (galThumbs.length > 0) {
        galThumbs.forEach(function (thumb) {
          thumb.addEventListener('click', function (e) {
            e.preventDefault();
            var targetIdx = parseInt(thumb.getAttribute('data-media-index'), 10);
            if (!isNaN(targetIdx) && galTrack.children[targetIdx]) {
              // Mark thumbnail as active immediately
              galThumbs.forEach(function (t) {
                t.classList.remove('is-active');
                t.setAttribute('aria-selected', 'false');
              });
              thumb.classList.add('is-active');
              thumb.setAttribute('aria-selected', 'true');

              // Scroll main gallery
              galTrack.children[targetIdx].scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'start' });
            }
          });
        });
      }
    }

    // Sticky mobile ATC visibility observer (sticks to bottom once scrolled past main buy button)
    var satc = document.getElementById('satc');
    var buyBlock = document.querySelector('.buys') || addBtn;
    if (satc && buyBlock) {
      function checkSatcScroll() {
        var rect = buyBlock.getBoundingClientRect();
        // Visible when buy buttons have scrolled past the top of the viewport
        var isPast = rect.bottom < 0;
        satc.classList.toggle('on', isPast);
      }

      if ('IntersectionObserver' in window) {
        var satcObserver = new IntersectionObserver(function (entries) {
          var entry = entries[0];
          var isPast = !entry.isIntersecting && entry.boundingClientRect.bottom < 0;
          satc.classList.toggle('on', isPast);
        }, { threshold: 0 });
        satcObserver.observe(buyBlock);
      }

      window.addEventListener('scroll', checkSatcScroll, { passive: true });
      checkSatcScroll();
    }

    // Sticky mobile ATC button click forwards to main add button or prompts size
    if (satcBtn) {
      satcBtn.addEventListener('click', function (e) {
        e.preventDefault();
        if (!validateSizeSelected()) {
          return;
        }

        // If current variant is available, trigger main Add to Bag
        if (addBtn && !addBtn.disabled) {
          addBtn.click();
        }
      });
    }

    // PDP form submit
    if (productForm) {
      productForm.addEventListener('submit', function (e) {
        e.preventDefault();
        if (!validateSizeSelected()) {
          return false;
        }
        var id = variantInput ? variantInput.value : null;
        var qty = qtyInput ? parseInt(qtyInput.value, 10) : 1;
        addToCart(id, qty, addBtn);
      });
    }
  }

  /* ============================================================
     WISHLIST CONTROLLER (LOCAL STORAGE PERSISTENCE)
     ============================================================ */
  var wishlistBound = false;

  function initWishlist() {
    var stored = [];
    try {
      stored = JSON.parse(localStorage.getItem('mc_wishlist') || '[]');
    } catch (e) {}

    // Initialize states on loaded cards
    document.querySelectorAll('.card, article').forEach(function (card) {
      var titleEl = card.querySelector('h3');
      var wishBtn = card.querySelector('.wish');
      if (titleEl && wishBtn) {
        var title = titleEl.textContent.trim();
        if (stored.indexOf(title) !== -1) {
          wishBtn.classList.add('active');
          wishBtn.textContent = '♥';
          wishBtn.setAttribute('aria-label', 'Remove from wishlist');
        }
      }
    });

    // Wishlist click handler (bound once — initWishlist re-runs after cards are injected)
    if (wishlistBound) return;
    wishlistBound = true;
    document.addEventListener('click', function (e) {
      var wishBtn = e.target.closest('.wish');
      if (!wishBtn) return;
      e.preventDefault();
      e.stopPropagation();

      wishBtn.classList.toggle('active');
      var isLiked = wishBtn.classList.contains('active');
      wishBtn.textContent = isLiked ? '♥' : '♡';
      wishBtn.setAttribute('aria-label', isLiked ? 'Remove from wishlist' : 'Save to wishlist');

      var card = wishBtn.closest('.card, article');
      var prodTitle = card && card.querySelector('h3') ? card.querySelector('h3').textContent.trim() : '';

      try {
        var list = JSON.parse(localStorage.getItem('mc_wishlist') || '[]');
        if (isLiked) {
          if (prodTitle && list.indexOf(prodTitle) === -1) list.push(prodTitle);
        } else {
          list = list.filter(function (t) { return t !== prodTitle; });
        }
        localStorage.setItem('mc_wishlist', JSON.stringify(list));
      } catch (err) {}
    });
  }

  /* ============================================================
     AUTO-FETCH RECOMMENDATIONS
     ============================================================ */
  function initRecommendations() {
    var recContainer = document.querySelector('.product-recommendations');
    if (!recContainer) return;
    var url = recContainer.getAttribute('data-url');
    if (!url) return;

    fetch(url)
      .then(function (res) { return res.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var newRail = temp.querySelector('#railRec');
        var oldRail = recContainer.querySelector('#railRec');
        if (newRail && oldRail && newRail.children.length > 0) {
          oldRail.innerHTML = newRail.innerHTML;
          initWishlist();
        }
      })
      .catch(function (err) {
        console.warn('Recommendations fetch warning:', err);
      });
  }

  /* ============================================================
     PDP COMPLETE THE LOOK — swap in Search & Discovery complementary picks
     ============================================================ */
  function initCrossSell() {
    document.querySelectorAll('[data-xsell-url]').forEach(function (sectionEl) {
      var url = sectionEl.getAttribute('data-xsell-url');
      var crossEl = sectionEl.querySelector('[data-xsell-cross]');
      if (!url || !crossEl) return;

      fetch(url)
        .then(function (res) { return res.text(); })
        .then(function (html) {
          var temp = document.createElement('div');
          temp.innerHTML = html;
          var comp = temp.querySelector('[data-xsell-comp]');
          if (!comp || !comp.querySelector('.card')) return; // no manual picks → keep category fallback

          // Skip picks already shown as bundle upsells
          var upsellLinks = [];
          sectionEl.querySelectorAll('[data-xsell-upsell] .card h3 a').forEach(function (a) {
            upsellLinks.push(a.getAttribute('href'));
          });
          comp.querySelectorAll('.card').forEach(function (card) {
            var a = card.querySelector('h3 a');
            if (a && upsellLinks.indexOf(a.getAttribute('href')) !== -1) card.remove();
          });
          if (!comp.querySelector('.card')) return;

          crossEl.innerHTML = comp.innerHTML;
          sectionEl.hidden = false;
          initWishlist();
        })
        .catch(function (err) {
          console.warn('Complementary picks fetch warning:', err);
        });
    });
  }

  /* In-page anchor smooth scroll (e.g. #shop-by-silhouette, #the-cuts, #the-index) */
  document.addEventListener('click', function (e) {
    var archBtn = e.target.closest('#dropsArchiveLink, .drops__archive, a[href*="#the-index"], a[href*="#the-cuts"], a[href*="#shop-by-silhouette"]');
    if (archBtn) {
      var href = archBtn.getAttribute('href') || '';
      var hash = href.indexOf('#') !== -1 ? href.substring(href.indexOf('#') + 1) : '';
      if (hash) {
        var indexTarget = document.getElementById(hash);
        if (indexTarget) {
          e.preventDefault();
          indexTarget.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    }
  });

  /* Safe account link handler on local dev to prevent proxy 401 disconnect */
  document.addEventListener('click', function (e) {
    var accLink = e.target.closest('a[href*="/account"]');
    if (accLink && (location.hostname === '127.0.0.1' || location.hostname === 'localhost')) {
      e.preventDefault();
      var storeDomain = (window.Shopify && window.Shopify.shop) ? window.Shopify.shop : 'c6360d-bd.myshopify.com';
      window.open('https://' + storeDomain + '/account', '_blank');
    }
  });

  /* ============================================================
     VIDEO CONTROLLER (UGC & SHOPPABLE REELS)
     ============================================================ */
  function initVideoController() {
    // Sound toggle buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-sound-toggle]');
      if (!btn) return;
      e.preventDefault();
      e.stopPropagation();

      var container = btn.closest('.ugc-card, .vid');
      if (!container) return;
      var video = container.querySelector('video');
      if (!video) return;

      var mutedIcon = btn.querySelector('.icon-muted');
      var unmutedIcon = btn.querySelector('.icon-unmuted');

      if (video.muted) {
        // Mute any other currently unmuted video
        document.querySelectorAll('video').forEach(function (v) {
          if (v !== video && !v.muted) {
            v.muted = true;
            var otherBtn = v.closest('.ugc-card, .vid') ? v.closest('.ugc-card, .vid').querySelector('[data-sound-toggle]') : null;
            if (otherBtn) {
              var m = otherBtn.querySelector('.icon-muted');
              var u = otherBtn.querySelector('.icon-unmuted');
              if (m) m.style.display = '';
              if (u) u.style.display = 'none';
            }
          }
        });

        video.muted = false;
        video.volume = 1;
        if (mutedIcon) mutedIcon.style.display = 'none';
        if (unmutedIcon) unmutedIcon.style.display = '';
        if (video.paused) video.play().catch(function () {});
      } else {
        video.muted = true;
        if (mutedIcon) mutedIcon.style.display = '';
        if (unmutedIcon) unmutedIcon.style.display = 'none';
      }
    });

    // Tap video to play/pause (if not clicking sound or link)
    document.addEventListener('click', function (e) {
      var video = e.target.closest('.ugc-card video, .vid video');
      if (!video) return;
      if (e.target.closest('[data-sound-toggle], [data-open-clip], [data-reel-modal], .shoppable-video-section, a, button')) return;

      if (video.paused) {
        video.play().catch(function () {});
      } else {
        video.pause();
      }
    });

    // IntersectionObserver for smart video loading & playback
    var isDataSaver = Boolean(
      (navigator.connection && (navigator.connection.saveData || navigator.connection.effectiveType === '2g' || navigator.connection.effectiveType === 'slow-2g')) ||
      (window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches)
    );

    if ('IntersectionObserver' in window) {
      var videoObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var vid = entry.target;
          if (entry.isIntersecting) {
            if (vid.preload === 'none') {
              vid.preload = 'metadata';
            }
            if (!isDataSaver && vid.paused && vid.hasAttribute('autoplay')) {
              vid.play().catch(function () {});
            }
          } else {
            if (!vid.paused && !vid.hasAttribute('data-keep-playing')) {
              vid.pause();
            }
          }
        });
      }, { rootMargin: '150px 0px', threshold: 0.1 });

      document.querySelectorAll('.ugc video, .vids video, .hero video').forEach(function (v) {
        videoObserver.observe(v);
      });
    }
  }

  /* ============================================================
     THEME TOGGLE CONTROLLER (LIGHT MODE DEFAULT)
     ============================================================ */
  function getPreferredTheme() {
    try {
      var stored = localStorage.getItem('mcx_theme');
      if (stored === 'dark' || stored === 'light') return stored;
    } catch (e) {}
    return 'light'; // Light mode as default
  }

  function setTheme(theme, save) {
    if (theme !== 'dark' && theme !== 'light') theme = 'light';

    document.documentElement.setAttribute('data-theme', theme);
    document.documentElement.classList.toggle('dark-mode', theme === 'dark');
    document.documentElement.classList.toggle('light-mode', theme === 'light');

    // Dynamic meta theme-color for mobile browser header chrome
    var metaTheme = document.getElementById('meta-theme-color');
    if (metaTheme) {
      metaTheme.setAttribute('content', theme === 'dark' ? '#000000' : '#FFFFFF');
    }

    // Sync all toggle buttons on page
    var toggles = document.querySelectorAll('[data-theme-toggle]');
    toggles.forEach(function (btn) {
      var isDark = theme === 'dark';
      btn.setAttribute('aria-checked', isDark ? 'true' : 'false');
      btn.setAttribute('title', isDark ? 'Switch to light mode' : 'Switch to dark mode');
      btn.setAttribute('aria-label', isDark ? 'Switch to light mode' : 'Switch to dark mode');
    });

    if (save !== false) {
      try {
        localStorage.setItem('mcx_theme', theme);
      } catch (e) {}
    }

    try {
      window.dispatchEvent(new CustomEvent('mcx:themechange', { detail: { theme: theme } }));
    } catch (e) {}
  }

  function initThemeToggle() {
    var initialTheme = getPreferredTheme();
    setTheme(initialTheme, false);

    document.addEventListener('click', function (e) {
      var toggleBtn = e.target.closest('[data-theme-toggle]');
      if (!toggleBtn) return;
      e.preventDefault();

      var current = document.documentElement.getAttribute('data-theme') || 'light';
      var nextTheme = current === 'dark' ? 'light' : 'dark';
      setTheme(nextTheme, true);
    });
  }

  window.MightyCuteTheme = {
    setTheme: setTheme,
    getTheme: getPreferredTheme
  };

  /* ============================================================
     COLLECTION STOREFRONT FILTERS & LIVE SIZE ENGINE
     ============================================================ */
  function initCollectionFilters() {
    var grid = document.getElementById('CollectionProductGrid');
    var chipsContainer = document.getElementById('CollectionActiveChips');
    var countEl = document.getElementById('CollectionProductCount');
    var drawerCountEl = document.getElementById('FilterDrawerProductCount');
    var filterBtn = document.querySelector('.fbar-filter-btn');
    var form = document.getElementById('FacetFiltersForm');
    var sizeResetBtn = document.getElementById('FacetResetBtn');
    var subcatResetBtn = document.getElementById('SubcatResetBtn');
    var sortBySelect = document.getElementById('SortBy');
    var pagination = document.getElementById('CollectionPagination');
    var segWrap = document.getElementById('CollectionSubcatSegregation');

    if (!grid && !form && !segWrap) return;

    var initialCount = 0;
    if (grid) {
      initialCount = grid.querySelectorAll('.card').length;
    }

    var subcatNames = {
      'hoodies': 'Winter Hoodies',
      'winter-hoodies': 'Winter Hoodies',
      'toji-barrel-fit': 'TOJI & Barrel Fit',
      'dark-grunge-pants': 'Baggy Pants',
      'core-basics': 'Core Basics',
      'gym-vests': 'Gym Vests & Tanks',
      'premium-tees': 'Premium Tees',
      'bundles-combos': 'Value Bundles',
      'mystery-boxes': 'Mystery Boxes',
      'clearance-vault': 'Clearance Vault'
    };

    function escapeHtml(str) {
      var div = document.createElement('div');
      div.textContent = str;
      return div.innerHTML;
    }

    // Get checked size values
    function getSelectedSizes() {
      var sizes = [];
      var checkedInputs = document.querySelectorAll('#FacetFiltersForm input[data-filter-size-input]:checked');
      checkedInputs.forEach(function (inp) {
        var v = (inp.value || '').trim().toLowerCase();
        if (v && sizes.indexOf(v) === -1) sizes.push(v);
      });
      return sizes;
    }

    // Get selected subcategory values
    function getSelectedSubcats() {
      var subcats = [];
      var checkedInputs = document.querySelectorAll('#FacetFiltersForm input[data-filter-subcat-input]:checked');
      checkedInputs.forEach(function (inp) {
        var v = (inp.value || '').trim().toLowerCase();
        if (v && subcats.indexOf(v) === -1) subcats.push(v);
      });
      return subcats;
    }

    // Apply combined subcategory & size filters
    function applyCombinedFilters(updateUrl) {
      var selectedSizes = getSelectedSizes();
      var selectedSubcats = getSelectedSubcats();
      var cards = grid ? grid.querySelectorAll('.card') : [];
      var visibleCount = 0;

      var hasFilters = selectedSizes.length > 0 || selectedSubcats.length > 0;

      // Filter each card
      cards.forEach(function (card) {
        var cardSizesAttr = (card.getAttribute('data-product-sizes') || '').toLowerCase();
        var cardSizes = cardSizesAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);

        var cardSubcatsAttr = (card.getAttribute('data-subcategory') || '').toLowerCase();
        var cardSubcats = cardSubcatsAttr.split(',').map(function (s) { return s.trim(); }).filter(Boolean);

        // Size check
        var sizeMatch = true;
        if (selectedSizes.length > 0) {
          sizeMatch = selectedSizes.some(function (sz) { return cardSizes.indexOf(sz) !== -1; });
        }

        // Subcategory check
        var subcatMatch = true;
        if (selectedSubcats.length > 0) {
          subcatMatch = selectedSubcats.some(function (sc) { return cardSubcats.indexOf(sc) !== -1; });
        }

        if (sizeMatch && subcatMatch) {
          card.style.display = '';
          visibleCount++;
        } else {
          card.style.display = 'none';
        }
      });

      // Update Subcategory Segregation Pills UI
      document.querySelectorAll('.subcat-seg-pill').forEach(function (pill) {
        var f = pill.getAttribute('data-subcat-filter');
        if (f === 'all') {
          if (selectedSubcats.length === 0) {
            pill.classList.add('is-active');
            pill.setAttribute('aria-selected', 'true');
          } else {
            pill.classList.remove('is-active');
            pill.setAttribute('aria-selected', 'false');
          }
        } else {
          if (selectedSubcats.indexOf(f) !== -1) {
            pill.classList.add('is-active');
            pill.setAttribute('aria-selected', 'true');
          } else {
            pill.classList.remove('is-active');
            pill.setAttribute('aria-selected', 'false');
          }
        }
      });

      // Update Filter Button Badge
      var totalActiveFilters = selectedSizes.length + selectedSubcats.length;
      if (filterBtn) {
        var badge = filterBtn.querySelector('.fbar-badge');
        if (totalActiveFilters > 0) {
          if (!badge) {
            badge = document.createElement('span');
            badge.className = 'fbar-badge';
            filterBtn.appendChild(badge);
          }
          badge.textContent = totalActiveFilters;
        } else if (badge) {
          badge.remove();
        }
      }

      // Update Resets
      if (sizeResetBtn) sizeResetBtn.style.display = selectedSizes.length > 0 ? 'inline-block' : 'none';
      if (subcatResetBtn) subcatResetBtn.style.display = selectedSubcats.length > 0 ? 'inline-block' : 'none';

      // Update piece count
      var totalPieces = hasFilters ? visibleCount : (initialCount || visibleCount);
      var totalStr = totalPieces + (totalPieces === 1 ? ' piece' : ' pieces');
      if (countEl) countEl.textContent = totalStr;
      if (drawerCountEl) drawerCountEl.textContent = '(' + totalStr + ')';

      // Render Active Filter Chips
      if (chipsContainer) {
        if (!hasFilters) {
          chipsContainer.innerHTML = '';
        } else {
          var chipsHtml = '<div class="chips">';
          // Subcategory Chips
          selectedSubcats.forEach(function (sc) {
            var label = subcatNames[sc] || sc;
            chipsHtml += '<button type="button" class="chip" data-remove-subcat="' + escapeHtml(sc) + '" aria-label="Remove category filter">';
            chipsHtml += 'Category: ' + escapeHtml(label) + ' <b>×</b></button>';
          });
          // Size Chips
          selectedSizes.forEach(function (sz) {
            var displayVal = sz.toUpperCase();
            var input = document.querySelector('#FacetFiltersForm input[data-filter-size-input][value="' + (window.CSS && CSS.escape ? CSS.escape(sz) : sz) + '"]');
            if (input) {
              var parentLabel = input.closest('.size-pill-label');
              var valSpan = parentLabel ? parentLabel.querySelector('.size-pill__val') : null;
              if (valSpan && valSpan.textContent) displayVal = valSpan.textContent.trim();
            }
            chipsHtml += '<button type="button" class="chip" data-remove-size="' + escapeHtml(sz) + '" aria-label="Remove size filter">';
            chipsHtml += 'Size: ' + escapeHtml(displayVal) + ' <b>×</b></button>';
          });
          chipsHtml += '<button type="button" class="chip chip--clear muted" id="ClearAllChipsBtn">Clear all</button>';
          chipsHtml += '</div>';
          chipsContainer.innerHTML = chipsHtml;
        }
      }

      // Handle No Matches Notice
      var existingNotice = document.getElementById('NoMatchingSizesNotice');
      if (visibleCount === 0 && hasFilters) {
        if (!existingNotice && grid) {
          var div = document.createElement('div');
          div.id = 'NoMatchingSizesNotice';
          div.className = 'muted sm';
          div.style.cssText = 'grid-column: 1 / -1; padding: 60px 0; text-align: center;';
          div.innerHTML = '<p style="font-size: var(--t-md); font-weight: 600; color: var(--c-paper); margin-bottom: 8px;">No products match the selected filters</p>' +
            '<p class="xs muted" style="margin-bottom: 20px;">Try switching subcategories or resetting filters.</p>' +
            '<button type="button" class="btn btn--sm btn--ghost" id="ClearNoMatchSizesBtn" style="display: inline-flex; width: auto;">Clear all filters</button>';
          grid.appendChild(div);
        }
        if (pagination) pagination.style.display = 'none';
      } else {
        if (existingNotice) existingNotice.remove();
        if (pagination) pagination.style.display = hasFilters ? 'none' : '';
      }

      // Update URL query parameters
      if (updateUrl) {
        var params = new URLSearchParams(window.location.search);
        var keysToRemove = [];
        params.forEach(function (val, key) {
          var k = key.toLowerCase();
          if (k.indexOf('filter.v.option.') === 0 || k === 'size' || k === 'subcat' || k.indexOf('filter.p.') === 0 || k.indexOf('filter.v.') === 0) {
            keysToRemove.push(key);
          }
        });
        keysToRemove.forEach(function (k) { params.delete(k); });

        if (selectedSubcats.length > 0) {
          params.set('subcat', selectedSubcats.join(','));
        }

        selectedSizes.forEach(function (sz) {
          var input = document.querySelector('#FacetFiltersForm input[data-filter-size-input][value="' + (window.CSS && CSS.escape ? CSS.escape(sz) : sz) + '"]');
          var paramName = input ? input.name : 'filter.v.option.size';
          params.append(paramName, sz);
        });

        params.delete('page');
        var qs = params.toString();
        var newUrl = window.location.pathname + (qs ? '?' + qs : '');
        window.history.pushState({ combinedFilters: true }, '', newUrl);
      }
    }

    // Clear all filters
    function clearAllFilters() {
      document.querySelectorAll('#FacetFiltersForm input[data-filter-size-input]').forEach(function (inp) {
        inp.checked = false;
        var label = inp.closest('.size-pill-label');
        if (label) label.classList.remove('active');
      });
      document.querySelectorAll('#FacetFiltersForm input[data-filter-subcat-input]').forEach(function (inp) {
        inp.checked = false;
      });
      applyCombinedFilters(true);
    }

    // Event Delegation for Subcat Pills
    document.addEventListener('click', function (e) {
      var pill = e.target.closest('.subcat-seg-pill');
      if (pill) {
        e.preventDefault();
        var filterVal = pill.getAttribute('data-subcat-filter');
        if (filterVal === 'all') {
          document.querySelectorAll('#FacetFiltersForm input[data-filter-subcat-input]').forEach(function (inp) {
            inp.checked = false;
          });
        } else {
          document.querySelectorAll('#FacetFiltersForm input[data-filter-subcat-input]').forEach(function (inp) {
            inp.checked = (inp.value === filterVal);
          });
        }
        applyCombinedFilters(true);
        return;
      }

      // Remove single chip
      var removeSubcatChip = e.target.closest('[data-remove-subcat]');
      if (removeSubcatChip) {
        e.preventDefault();
        var sc = removeSubcatChip.getAttribute('data-remove-subcat');
        document.querySelectorAll('#FacetFiltersForm input[data-filter-subcat-input][value="' + sc + '"]').forEach(function (inp) {
          inp.checked = false;
        });
        applyCombinedFilters(true);
        return;
      }

      var removeSizeChip = e.target.closest('[data-remove-size]');
      if (removeSizeChip) {
        e.preventDefault();
        var sz = (removeSizeChip.getAttribute('data-remove-size') || '').trim().toLowerCase();
        document.querySelectorAll('#FacetFiltersForm input[data-filter-size-input]').forEach(function (inp) {
          if ((inp.value || '').trim().toLowerCase() === sz) {
            inp.checked = false;
            var label = inp.closest('.size-pill-label');
            if (label) label.classList.remove('active');
          }
        });
        applyCombinedFilters(true);
        return;
      }

      if (e.target && (e.target.id === 'ClearAllChipsBtn' || e.target.id === 'FilterClearAllBtn' || e.target.id === 'ClearNoMatchSizesBtn')) {
        e.preventDefault();
        clearAllFilters();
        return;
      }

      if (e.target && e.target.id === 'SubcatResetBtn') {
        e.preventDefault();
        document.querySelectorAll('#FacetFiltersForm input[data-filter-subcat-input]').forEach(function (inp) {
          inp.checked = false;
        });
        applyCombinedFilters(true);
        return;
      }

      if (e.target && e.target.id === 'FacetResetBtn') {
        e.preventDefault();
        document.querySelectorAll('#FacetFiltersForm input[data-filter-size-input]').forEach(function (inp) {
          inp.checked = false;
          var label = inp.closest('.size-pill-label');
          if (label) label.classList.remove('active');
        });
        applyCombinedFilters(true);
        return;
      }

      if (e.target && e.target.id === 'FilterApplyBtn') {
        e.preventDefault();
        closeAllOverlays();
        applyCombinedFilters(true);
        return;
      }
    });

    // Checkbox changes inside form
    document.addEventListener('change', function (e) {
      if (e.target && e.target.matches('#FacetFiltersForm [data-filter-size-input]')) {
        var label = e.target.closest('.size-pill-label');
        if (label) {
          if (e.target.checked) label.classList.add('active');
          else label.classList.remove('active');
        }
      }
      if (e.target && e.target.matches('#FacetFiltersForm [data-filter-subcat-input]')) {
        // Run live update if drawer is open or inline
        applyCombinedFilters(true);
      }
    });

    // SortBy preservation
    if (sortBySelect) {
      sortBySelect.addEventListener('change', function () {
        var params = new URLSearchParams(window.location.search);
        params.set('sort_by', this.value);
        params.delete('page');
        window.location.href = window.location.pathname + '?' + params.toString();
      });
    }

    // Form submission
    document.addEventListener('submit', function (e) {
      if (e.target && e.target.id === 'FacetFiltersForm') {
        e.preventDefault();
        closeAllOverlays();
        applyCombinedFilters(true);
      }
    });

    // Sync from URL
    function syncFromUrl() {
      var params = new URLSearchParams(window.location.search);
      var urlSubcat = params.get('subcat');
      if (urlSubcat) {
        var subcatsArray = urlSubcat.split(',').map(function (s) { return s.trim().toLowerCase(); });
        document.querySelectorAll('#FacetFiltersForm [data-filter-subcat-input]').forEach(function (inp) {
          inp.checked = subcatsArray.indexOf(inp.value.toLowerCase()) !== -1;
        });
      }

      var urlSizes = [];
      params.forEach(function (val, key) {
        var k = key.toLowerCase();
        if (k.indexOf('filter.v.option.') === 0 || k === 'size' || k.indexOf('filter.p.') === 0) {
          var v = (val || '').trim().toLowerCase();
          if (v && urlSizes.indexOf(v) === -1) urlSizes.push(v);
        }
      });

      if (urlSizes.length > 0) {
        document.querySelectorAll('#FacetFiltersForm [data-filter-size-input]').forEach(function (inp) {
          var v = (inp.value || '').trim().toLowerCase();
          if (urlSizes.indexOf(v) !== -1) {
            inp.checked = true;
            var label = inp.closest('.size-pill-label');
            if (label) label.classList.add('active');
          }
        });
      }

      if (urlSubcat || urlSizes.length > 0) {
        applyCombinedFilters(false);
      }
    }

    syncFromUrl();

    // Browser navigation back/forward
    window.addEventListener('popstate', function () {
      document.querySelectorAll('#FacetFiltersForm [data-filter-size-input]').forEach(function (inp) {
        inp.checked = false;
        var label = inp.closest('.size-pill-label');
        if (label) label.classList.remove('active');
      });
      document.querySelectorAll('#FacetFiltersForm [data-filter-subcat-input]').forEach(function (inp) {
        inp.checked = false;
      });
      syncFromUrl();
      applyCombinedFilters(false);
    });
  }


  /* ============================================================
     WINTER AMBIENT SNOWFALL SYSTEM (SCOPED TO HOODIE PAGES)
     Multi-depth buttery canvas particles with drift & toggle
     ============================================================ */
  function initWinterSnowfall() {
    var canvas = document.getElementById('winter-snow-canvas');
    var toggleBtn = document.getElementById('winter-snow-toggle');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    if (!ctx) return;

    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var savedState = null;
    try {
      savedState = localStorage.getItem('mcx_snow_enabled');
    } catch (e) {}

    var isEnabled = savedState !== null ? savedState === 'true' : !reducedMotion;
    var animFrameId = null;
    var particles = [];
    var width = 0;
    var height = 0;

    function resize() {
      width = canvas.width = window.innerWidth;
      height = canvas.height = window.innerHeight;
    }

    function createParticle() {
      return {
        x: Math.random() * width,
        y: Math.random() * height,
        r: Math.random() * 2.2 + 0.8,
        opacity: Math.random() * 0.6 + 0.25,
        speedY: Math.random() * 1.4 + 0.6,
        speedX: Math.random() * 0.5 - 0.2,
        swayAngle: Math.random() * Math.PI * 2,
        swaySpeed: Math.random() * 0.02 + 0.008,
        swayRange: Math.random() * 1.5 + 0.5
      };
    }

    function initParticles() {
      var count = window.innerWidth < 768 ? 32 : 65;
      particles = [];
      for (var i = 0; i < count; i++) {
        particles.push(createParticle());
      }
    }

    function draw() {
      if (!isEnabled) return;
      ctx.clearRect(0, 0, width, height);

      var isDark = document.documentElement.getAttribute('data-theme') === 'dark';
      var r = isDark ? 224 : 255;
      var g = isDark ? 242 : 255;
      var b = isDark ? 254 : 255;

      for (var i = 0; i < particles.length; i++) {
        var p = particles[i];
        p.swayAngle += p.swaySpeed;
        p.y += p.speedY;
        p.x += p.speedX + Math.sin(p.swayAngle) * p.swayRange * 0.4;

        if (p.y > height + 10) {
          p.y = -10;
          p.x = Math.random() * width;
        }
        if (p.x > width + 10) {
          p.x = -10;
        } else if (p.x < -10) {
          p.x = width + 10;
        }

        ctx.beginPath();
        ctx.arc(p.x, p.y, p.r, 0, Math.PI * 2);
        ctx.fillStyle = 'rgba(' + r + ',' + g + ',' + b + ',' + p.opacity + ')';
        ctx.fill();
      }

      animFrameId = requestAnimationFrame(draw);
    }

    function start() {
      if (!isEnabled) return;
      canvas.classList.remove('is-hidden');
      if (toggleBtn) {
        toggleBtn.classList.remove('is-paused');
        toggleBtn.setAttribute('title', 'Snowfall: Active (Click to pause)');
        toggleBtn.setAttribute('aria-pressed', 'true');
      }
      if (!animFrameId) {
        animFrameId = requestAnimationFrame(draw);
      }
    }

    function stop() {
      if (animFrameId) {
        cancelAnimationFrame(animFrameId);
        animFrameId = null;
      }
      ctx.clearRect(0, 0, width, height);
      canvas.classList.add('is-hidden');
      if (toggleBtn) {
        toggleBtn.classList.add('is-paused');
        toggleBtn.setAttribute('title', 'Snowfall: Paused (Click to enable)');
        toggleBtn.setAttribute('aria-pressed', 'false');
      }
    }

    function toggle() {
      isEnabled = !isEnabled;
      try {
        localStorage.setItem('mcx_snow_enabled', String(isEnabled));
      } catch (e) {}
      if (isEnabled) {
        start();
      } else {
        stop();
      }
    }

    resize();
    initParticles();

    if (isEnabled) {
      start();
    } else {
      stop();
    }

    if (toggleBtn) {
      toggleBtn.addEventListener('click', function (e) {
        e.preventDefault();
        toggle();
      });
    }

    window.addEventListener('resize', function () {
      resize();
    }, { passive: true });

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) {
        if (animFrameId) {
          cancelAnimationFrame(animFrameId);
          animFrameId = null;
        }
      } else if (isEnabled) {
        start();
      }
    });
  }

  /* ============================================================
     PRODUCT CARD INLINE SIZES (size pills + Add to Cart on the card)
     ============================================================ */
  function initCardSizes() {
    document.addEventListener('click', function (e) {
      var sizeBtn = e.target.closest('[data-card-size]');
      if (sizeBtn) {
        e.preventDefault();
        var group = sizeBtn.closest('.card-sizes');
        if (!group) return;
        group.querySelectorAll('[data-card-size]').forEach(function (b) {
          b.setAttribute('aria-pressed', b === sizeBtn ? 'true' : 'false');
        });
        group.classList.remove('pulse-attention');
        return;
      }

      var atcBtn = e.target.closest('[data-card-atc]');
      if (!atcBtn) return;
      e.preventDefault();
      var card = atcBtn.closest('.card, .xd-card'); // product cards + cart drawer deal rail
      var picked = card ? card.querySelector('.card-sizes [aria-pressed="true"]') : null;
      if (!picked) {
        var sizes = card ? card.querySelector('.card-sizes') : null;
        if (sizes) {
          sizes.classList.remove('pulse-attention');
          void sizes.offsetWidth; // restart the animation
          sizes.classList.add('pulse-attention');
        }
        if (!atcBtn.disabled) {
          atcBtn.textContent = 'Select size';
          clearTimeout(atcBtn._labelTimer);
          atcBtn._labelTimer = setTimeout(function () { atcBtn.textContent = 'Add to Cart'; }, 1400);
        }
        return;
      }
      // Cancel a pending "Select size" reset so addToCart restores the right label
      clearTimeout(atcBtn._labelTimer);
      atcBtn.textContent = 'Add to Cart';
      addToCart(picked.getAttribute('data-card-size'), 1, atcBtn);
    });
  }

  /* ============================================================
     PRODUCT CARD QUICK ADD (home, collection, PDP cross-sell)
     "+ Add" → pick Size (and Bundle/Style) in #quickAdd → /cart/add.js → cart drawer.
     Variant data comes from Shopify's native /products/{handle}.js.
     ============================================================ */
  function initCardQuickAdd() {
    var sheet = document.getElementById('quickAdd');
    if (!sheet) return;

    var imgEl = document.getElementById('qaImg');
    var titleEl = document.getElementById('qaTitle');
    var priceEl = document.getElementById('qaPrice');
    var wasEl = document.getElementById('qaWas');
    var linkEl = document.getElementById('qaLink');
    var optsEl = document.getElementById('qaOptions');
    var msgEl = document.getElementById('qaMsg');
    var addBtnEl = document.getElementById('qaAddBtn');

    var cache = {};
    var current = null; // { product, selected: [] }

    function sizedUrl(url, width) {
      if (!url) return '';
      var src = typeof url === 'string' ? url : (url.src || '');
      return src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=' + width;
    }

    function isSizeOption(name) {
      return /size|waist/i.test(name || '');
    }

    function findVariant(product, selected) {
      return product.variants.find(function (v) {
        for (var i = 0; i < product.options.length; i++) {
          if (selected[i] == null || cleanVal(v.options[i]) !== cleanVal(selected[i])) return false;
        }
        return true;
      });
    }

    // A value is selectable if some available variant has it, given the other options already picked
    function valueAvailable(product, selected, optIdx, value) {
      return product.variants.some(function (v) {
        if (!v.available || cleanVal(v.options[optIdx]) !== cleanVal(value)) return false;
        for (var i = 0; i < product.options.length; i++) {
          if (i === optIdx || selected[i] == null) continue;
          if (cleanVal(v.options[i]) !== cleanVal(selected[i])) return false;
        }
        return true;
      });
    }

    function showMsg(text) {
      if (!msgEl) return;
      msgEl.textContent = text || '';
      msgEl.hidden = !text;
    }

    function render() {
      var product = current.product;
      var selected = current.selected;
      var variant = findVariant(product, selected);
      var shown = variant || product.variants.find(function (v) { return v.available; }) || product.variants[0];

      priceEl.textContent = formatMoney(shown.price);
      if (shown.compare_at_price > shown.price) {
        wasEl.textContent = formatMoney(shown.compare_at_price);
        wasEl.style.display = '';
      } else {
        wasEl.style.display = 'none';
      }
      if (variant && variant.featured_image) imgEl.src = sizedUrl(variant.featured_image, 240);

      var html = '';
      product.options.forEach(function (opt, idx) {
        var name = opt.name || opt;
        var values = opt.values || [];
        html += '<div class="optrow qa-sheet__row">' +
          '<div class="top"><span class="xs">' + name + (selected[idx] ? ': <b>' + selected[idx] + '</b>' : '') + '</span></div>' +
          '<div class="sizes">';
        values.forEach(function (val) {
          var ok = valueAvailable(product, selected, idx, val);
          var pressed = selected[idx] != null && cleanVal(selected[idx]) === cleanVal(val);
          html += '<button type="button" data-qa-opt="' + idx + '" data-qa-val="' + String(val).replace(/"/g, '&quot;') + '" aria-pressed="' + pressed + '"' + (ok ? '' : ' disabled') + '>' + val + '</button>';
        });
        html += '</div></div>';
      });
      optsEl.innerHTML = html;

      var complete = product.options.every(function (o, i) { return selected[i] != null; });
      addBtnEl.disabled = !!(complete && (!variant || !variant.available));
      addBtnEl.textContent = (complete && variant && !variant.available) ? 'Sold out' : 'Add to Cart — ' + formatMoney(shown.price);
    }

    function open(product, triggerEl) {
      var selected = [];
      product.options.forEach(function (opt, idx) {
        var values = opt.values || [];
        // Pre-pick single-value options and non-size options (first available); size is always the shopper's choice
        if (values.length === 1) {
          selected[idx] = values[0];
        } else if (!isSizeOption(opt.name)) {
          var firstOk = values.find(function (val) { return valueAvailable(product, [], idx, val); });
          selected[idx] = firstOk != null ? firstOk : values[0];
        }
      });
      current = { product: product, selected: selected, trigger: triggerEl };

      if (product.featured_image) imgEl.src = sizedUrl(product.featured_image, 240);
      imgEl.alt = product.title;
      titleEl.textContent = product.title;
      linkEl.href = product.url || ('/products/' + product.handle);
      showMsg('');
      render();
      openDrawer('quickAdd');
      var firstBtn = optsEl.querySelector('button:not([disabled])');
      if (firstBtn) firstBtn.focus({ preventScroll: true });
    }

    document.addEventListener('click', function (e) {
      var trigger = e.target.closest('[data-card-qa]');
      if (trigger) {
        e.preventDefault();
        e.stopPropagation();
        var directVariant = trigger.getAttribute('data-card-qa-variant');
        if (directVariant) {
          addToCart(directVariant, 1, trigger);
          return;
        }
        var handle = trigger.getAttribute('data-card-qa');
        // Show the card's already-loaded photo instantly; the product image replaces it once fetched
        var cardImg = trigger.closest('.card') && trigger.closest('.card').querySelector('.media img');
        if (cardImg && cardImg.currentSrc) imgEl.src = cardImg.currentSrc;
        if (cache[handle]) {
          open(cache[handle], trigger);
          return;
        }
        trigger.disabled = true;
        fetch((window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') + 'products/' + handle + '.js')
          .then(function (res) {
            if (!res.ok) throw new Error('Product fetch failed');
            return res.json();
          })
          .then(function (product) {
            cache[handle] = product;
            open(product, trigger);
          })
          .catch(function (err) {
            console.error('Quick add error:', err);
            window.location.href = trigger.closest('.card') && trigger.closest('.card').querySelector('a[href]') ? trigger.closest('.card').querySelector('a[href]').href : '/products/' + handle;
          })
          .finally(function () {
            trigger.disabled = false;
          });
        return;
      }

      var optBtn = e.target.closest('[data-qa-opt]');
      if (optBtn && current && sheet.contains(optBtn)) {
        e.preventDefault();
        var idx = parseInt(optBtn.getAttribute('data-qa-opt'), 10);
        current.selected[idx] = optBtn.getAttribute('data-qa-val');
        // Drop picks that became impossible after this change
        current.product.options.forEach(function (o, i) {
          if (i !== idx && current.selected[i] != null && !valueAvailable(current.product, current.selected, i, current.selected[i])) {
            if (isSizeOption(o.name)) current.selected[i] = null;
          }
        });
        showMsg('');
        render();
      }
    });

    addBtnEl.addEventListener('click', function (e) {
      e.preventDefault();
      if (!current) return;
      var product = current.product;
      var missing = product.options.find(function (o, i) { return current.selected[i] == null; });
      if (missing) {
        showMsg('Select ' + (missing.name || 'an option').toLowerCase());
        return;
      }
      var variant = findVariant(product, current.selected);
      if (!variant || !variant.available) {
        showMsg('Sold out');
        return;
      }
      addToCart(variant.id, 1, addBtnEl);
    });
  }

  /* ============================================================
     SAFE MASTER LIFECYCLE INITIALIZER
     ============================================================ */
  function initAll() {
    initThemeToggle();
    initWinterSnowfall();
    initCollectionFilters();
    initDrawers();
    refreshCartDrawer();
    initCartHandlers();
    initProductPage();
    initRecommendations();
    initCrossSell();
    initWishlist();
    initCardSizes();
    initCardQuickAdd();
    initVideoController();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();
